module.exports = __webpack_public_path__ + "img/lt-tiengviet1.07ac709f.png";